import React, {useState} from 'react';
import styles from './OptionListFilters.module.sass';
import Button from 'Components/Atoms/Button/Button';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import {faXmark} from '@fortawesome/pro-light-svg-icons';
import {useDropdown} from 'Components/Atoms/Dropdown/Dropdown';
import FilterTabStatus from 'Components/Molecules/Filters/FilterTabStatus/FilterTabStatus';
import {optionListStatusColorMap, optionListStatusMap} from 'Components/Organisms/OptionList/Options';
import FilterTabDateRange from 'Components/Molecules/Filters/FilterTabDateRange/FilterTabDateRange';

const OptionListFilters = ({
    filters, onFilterChange
}: any) => {
    const { closeDropdown } = useDropdown();
    const [state, setState] = useState({
        activeFilter: ''
    });

    const [data, setData] = useState<any>(filters);

    const handleTabClick = (key: string) => () => setState((state) => ({
        ...state,
        activeFilter: state.activeFilter === key ? '' : key
    }));
    const handleFilterClick = (key: any) => (value: any) => {
        setData((prevData) => {
            const filters = { ...prevData };

            if (!Array.isArray(value)) {
                value = [value];
            }

            for (const valueItem of value) {
                if (filters[key]?.includes(valueItem)) {
                    filters[key] = filters[key].filter((i) => i !== valueItem);
                    if (filters[key].length === 0) {
                        delete filters[key];
                    }
                } else {
                    filters[key] = [...(filters[key] ?? []), valueItem];
                }
            }

            console.log(filters);

            return filters;
        });
    }

    const handleFilterChange = () => {
        onFilterChange(data);
        closeDropdown();
    };

    const resetFilters = () => {
        let resetFilters: any = {};
        if (filters?.query) {
            resetFilters.query = filters.query;
        }

        onFilterChange(resetFilters);
        closeDropdown();
    };

    return <div className={styles['optionlistfilters']}>
        <div className={styles['optionlistfilters__header']}>
            Filter instellen
            <Button
                variant='transparent'
                color='dark'
                size='medium'
                iconBefore={<FontAwesomeIcon icon={faXmark} />}
                onClick={closeDropdown}
            />
        </div>
        <div className={styles['optionlistfilters__content']}>
            <FilterTabStatus
                isOpen={state?.activeFilter === 'status'}
                values={data?.['status'] ?? []}
                filterList={
                    Object.keys(optionListStatusMap).map((key) => ({
                        status: optionListStatusColorMap[key],
                        label: optionListStatusMap[key],
                        value: key
                    }))
                }
                onTabClick={handleTabClick('status')}
                onFilterClick={handleFilterClick('status')}
            />

            <FilterTabDateRange
                title={'Verzonden op (t/m)'}
                values={data?.['sent_at'] ?? []}
                isOpen={state?.activeFilter === 'sent_at'}
                onTabClick={handleTabClick('sent_at')}
                onFilterClick={handleFilterClick('sent_at')}
            />
            <FilterTabDateRange
                title={'Aangepast op (t/m)'}
                values={data?.['updated_between'] ?? []}
                isOpen={state?.activeFilter === 'updated_between'}
                onTabClick={handleTabClick('updated_between')}
                onFilterClick={handleFilterClick('updated_between')}
            />
            <FilterTabDateRange
                title={'Aangemaakt op (t/m)'}
                values={data?.['created_between'] ?? []}
                isOpen={state?.activeFilter === 'created_between'}
                onTabClick={handleTabClick('created_between')}
                onFilterClick={handleFilterClick('created_between')}
            />
        </div>
        <div className={styles['optionlistfilters__footer']}>
            <Button
                variant='solid'
                color='primary'
                size='small'
                onClick={handleFilterChange}
            >
                Filter opslaan
            </Button>
            <Button
                variant='transparent'
                color='primary'
                size='small'
                onClick={resetFilters}
            >
                Alle filters resetten
            </Button>
        </div>
    </div>
}

export default OptionListFilters;